"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedElementsQueryResult = exports.DecoratedElementsQuery = exports.DecoratedElementsQueryFactory = void 0;
var tslib_1 = require("tslib");
/**
 * @alpha
 */
var DecoratedElementsQueryFactory = /** @class */ (function () {
    function DecoratedElementsQueryFactory(decorated) {
        this.decorated = decorated;
    }
    DecoratedElementsQueryFactory.prototype.forDisplayForm = function (ref) {
        return this.decorated.forDisplayForm(ref);
    };
    DecoratedElementsQueryFactory.prototype.forFilter = function (filter, dateFilterDisplayForm) {
        return this.decorated.forFilter(filter, dateFilterDisplayForm);
    };
    return DecoratedElementsQueryFactory;
}());
exports.DecoratedElementsQueryFactory = DecoratedElementsQueryFactory;
/**
 * @alpha
 */
var DecoratedElementsQuery = /** @class */ (function () {
    function DecoratedElementsQuery(decorated, settings) {
        if (settings === void 0) { settings = {}; }
        this.decorated = decorated;
        this.settings = settings;
    }
    DecoratedElementsQuery.prototype.withLimit = function (limit) {
        return this.createNew(this.decorated.withLimit(limit), tslib_1.__assign(tslib_1.__assign({}, this.settings), { limit: limit }));
    };
    DecoratedElementsQuery.prototype.withOffset = function (offset) {
        return this.createNew(this.decorated.withOffset(offset), tslib_1.__assign(tslib_1.__assign({}, this.settings), { offset: offset }));
    };
    DecoratedElementsQuery.prototype.withAttributeFilters = function (attributeFilters) {
        return this.createNew(this.decorated.withAttributeFilters(attributeFilters), tslib_1.__assign(tslib_1.__assign({}, this.settings), { attributeFilters: attributeFilters }));
    };
    DecoratedElementsQuery.prototype.withMeasures = function (measures) {
        return this.createNew(this.decorated.withMeasures(measures), tslib_1.__assign(tslib_1.__assign({}, this.settings), { measures: measures }));
    };
    DecoratedElementsQuery.prototype.withOptions = function (options) {
        return this.createNew(this.decorated.withOptions(options), tslib_1.__assign(tslib_1.__assign({}, this.settings), { options: options }));
    };
    DecoratedElementsQuery.prototype.query = function () {
        return this.decorated.query();
    };
    DecoratedElementsQuery.prototype.withDateFilters = function (dateFilters) {
        return this.createNew(this.decorated.withDateFilters(dateFilters), tslib_1.__assign(tslib_1.__assign({}, this.settings), { dateFilters: dateFilters }));
    };
    DecoratedElementsQuery.prototype.withSignal = function (signal) {
        return this.decorated.withSignal(signal);
    };
    return DecoratedElementsQuery;
}());
exports.DecoratedElementsQuery = DecoratedElementsQuery;
/**
 * @alpha
 */
var DecoratedElementsQueryResult = /** @class */ (function () {
    function DecoratedElementsQueryResult(decorated, items, limit, offset, totalCount) {
        this.decorated = decorated;
        this.items = items;
        this.limit = limit;
        this.offset = offset;
        this.totalCount = totalCount;
    }
    DecoratedElementsQueryResult.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decorated.next()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.createNew(result, result.items, result.limit, result.offset, result.totalCount)];
                }
            });
        });
    };
    DecoratedElementsQueryResult.prototype.goTo = function (pageIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.decorated.goTo(pageIndex)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.createNew(result, result.items, result.limit, result.offset, result.totalCount)];
                }
            });
        });
    };
    DecoratedElementsQueryResult.prototype.all = function () {
        return this.decorated.all();
    };
    DecoratedElementsQueryResult.prototype.allSorted = function (compareFn) {
        return this.decorated.allSorted(compareFn);
    };
    return DecoratedElementsQueryResult;
}());
exports.DecoratedElementsQueryResult = DecoratedElementsQueryResult;
//# sourceMappingURL=elements.js.map